"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionObserverService = void 0;
var abstract_lazyload_service_1 = require("./abstract-lazyload.service");
/**
 * This class is an implementation of Kobi fragment lazy-load.
 * It uses:
 *  - the [IntersectionObserver Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API}
 *  - the abstract service to call Kobi endpoint and handle the response
 *
 *  You can customize:
 *  - options of the [IntersectionObserver Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API}
 *  - error handler
 *  - lazy-loading configuration as event bus name, attribute name on placeholder, etc.
 */
var IntersectionObserverService = /** @class */ (function (_super) {
    __extends(IntersectionObserverService, _super);
    /**
     * Constructor to instantiate IntersectionObserverService that handle Fragment lazy-loading on your site.
     * @param options options of the [IntersectionObserver Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API}
     * @param configuration Custom lazy-loading configuration; by default DefaultConfiguration
     * @param errorHandler Custom error handler; by default new ErrorHandler()
     */
    function IntersectionObserverService(options, configuration, errorHandler) {
        var _this = _super.call(this, configuration, errorHandler) || this;
        _this.observer = null;
        _this.fragments = [];
        _this.options = options;
        document.addEventListener('DOMContentLoaded', function () {
            _this.fragments = Array.from(document.querySelectorAll("*[".concat(_this.configuration.fragmentPlaceholderConfig.lazyLoadUrlAttribute, "]")));
            _this.initIntersectionObserver();
            _this.logger.debug('IntersectionObserver is initialized with this configuration', _this.options);
        });
        return _this;
    }
    IntersectionObserverService.prototype.initIntersectionObserver = function () {
        var _this = this;
        this.observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    _this.logger.debug("Fragment placeholder with id ".concat(entry.target.getAttribute(_this.configuration.fragmentPlaceholderConfig.FragmentIdAttribute), " is intersecting"));
                    observer.unobserve(entry.target);
                    _this.triggerLazyLoad(entry.target).then();
                }
            });
        }, this.options);
        this.fragments.forEach(function (fragment) {
            var _a;
            if (_this.setAttributeWhenFollow(fragment)) {
                _this.logger.debug("Fragment placeholder with id ".concat(fragment.getAttribute(_this.configuration.fragmentPlaceholderConfig.FragmentIdAttribute), " is observed"));
                (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.observe(fragment);
            }
        });
        this.fragments = [];
    };
    /**
     * It permits to observe new element in DOM after to have lazy loaded new fragments.
     */
    IntersectionObserverService.prototype.newLazyLoadFragmentHasBeenPush = function () {
        var _this = this;
        this.fragments = Array.from(document.querySelectorAll("*[".concat(this.configuration.fragmentPlaceholderConfig.lazyLoadUrlAttribute, "]")));
        this.fragments.forEach(function (fragment) {
            var _a;
            if (_this.setAttributeWhenFollow(fragment)) {
                (_a = _this.observer) === null || _a === void 0 ? void 0 : _a.observe(fragment);
                _this.logger.debug("Fragment placeholder with id ".concat(fragment.getAttribute(_this.configuration.fragmentPlaceholderConfig.FragmentIdAttribute), " is now observed"));
            }
        });
        this.fragments = [];
    };
    IntersectionObserverService.prototype.setAttributeWhenFollow = function (fragmentPlaceholder) {
        if (!fragmentPlaceholder.getAttribute(this.configuration.fragmentPlaceholderConfig.toSetWhenFollow) && !fragmentPlaceholder.hidden) {
            fragmentPlaceholder.setAttribute(this.configuration.fragmentPlaceholderConfig.toSetWhenFollow, 'true');
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Get a cloned HTML Element (node) of the lazy fragment's placeholder.
     * You need to add this node to your DOM (ex: page of SPA) and call newLazyLoadFragmentHasBeenPush() function
     * to observe and lazy load it.
     * @param fragmentId the ID of the Fragment
     * @return the HTML Element (node)
     */
    IntersectionObserverService.prototype.getFragmentPlaceholderNodeById = function (fragmentId) {
        var lazyFragmentPlaceholder = document.querySelector("[".concat(this.configuration.fragmentPlaceholderConfig.FragmentIdAttribute, "='").concat(fragmentId, "'][").concat(this.configuration.fragmentPlaceholderConfig.lazyLoadUrlAttribute, "]"));
        if (lazyFragmentPlaceholder) {
            var lazyFragmentPlaceholderClone = lazyFragmentPlaceholder.cloneNode(true);
            lazyFragmentPlaceholderClone.hidden = false;
            return lazyFragmentPlaceholderClone;
        }
        else {
            return undefined;
        }
    };
    IntersectionObserverService.prototype.handleResponse = function (kobiFragmentId, target, html) {
        _super.prototype.handleResponse.call(this, kobiFragmentId, target, html);
        this.newLazyLoadFragmentHasBeenPush();
    };
    return IntersectionObserverService;
}(abstract_lazyload_service_1.AbstractLazyLoadService));
exports.IntersectionObserverService = IntersectionObserverService;
//# sourceMappingURL=intersection-observer.service.js.map